import projection from '../generated/pwc5n4f1.json';
import { AcceptanceManifest } from '../types';
export const pwc5n4f1AcceptanceManifest = projection as AcceptanceManifest;
